import { ITransaction } from '@typings/platform'
import { Abstract } from './Abstract'

/**
 * @class TransactionList
 * @property {number} datetime Time of transaction
 * @property {string} paymentMethod paymentMethod of transaction
 * @property {boolean} isRecurring isRecurring of transaction
 * @property {string} externalProductId externalProductId of transaction
 * @property {string} productId productId of transaction
 * @property {string} productType productType of transaction
 * @property {string} productName productName of transaction
 * @property {string} currencyCode currencyCode of transaction
 * @property {string} priceFinal priceFinal of transaction
 * @property {number} rentalStartDate rentalStartDate of transaction
 * @property {number} rentalEndDate rentalEndDate of transaction
 * @property {string} purchaseType purchaseType of transaction
 * @property {string} transactionId transactionId of transaction
 * @property {string} transactionStatus transactionStatus of transaction
 * @property {string} device device of transaction
 * @property {string} deviceId deviceId of transaction
 * @property {string} userIpAddress userIpAddress of transaction
 */

export class TransactionList extends Abstract {
    datetime: number
    paymentMethod: string
    isRecurring: boolean
    externalProductId: string
    productId: string
    productType: string
    productName: string
    currencyCode: string
    priceFinal: string
    rentalStartDate: number
    rentalEndDate: number
    purchaseType: string
    transactionId: string
    transactionStatus: string
    device: string
    deviceId: string
    userIpAddress: string

    constructor(props: ITransaction) {
        super()
        this.datetime = props.datetime
        this.paymentMethod = props.paymentMethod
        this.isRecurring = props.isRecurring
        this.externalProductId = props.externalProductId
        this.productId = props.productId
        this.productType = props.productType
        this.productName = props.productName
        this.currencyCode = props.currencyCode
        this.priceFinal = props.priceFinal
        this.rentalStartDate = props.rentalStartDate
        this.rentalEndDate = props.rentalEndDate
        this.purchaseType = props.purchaseType
        this.transactionId = props.transactionId
        this.transactionStatus = props.transactionStatus
        this.device = props.device
        this.deviceId = props.deviceId
        this.userIpAddress = props.userIpAddress
    }
}
